import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ClientPaymentAndOrderApi } from '../../../services/clientPaymentAndOrderService';



export const fetchProductAvailablePropertiesBeforeCheckout = createAsyncThunk(
    'clientOrderAndPayment/fetchProductAvailablePropertiesBeforeCheckout',
    async (productId, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000));

            const response = await ClientPaymentAndOrderApi.fetchProductAvailablePropertiesBeforeCheckout(productId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const priceCalculatorBeforeCheckout = createAsyncThunk(
    'clientOrderAndPayment/priceCalculatorBeforeCheckout',
    async ({ productId, formData }, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000));


            const response = await ClientPaymentAndOrderApi.priceCalculatorBeforeCheckout(productId, formData);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const fetchProductDetail = createAsyncThunk(
    'clientOrderAndPayment/fetchProductDetail',
    async (productId, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000));

            const response = await ClientPaymentAndOrderApi.fetchProductDetail(productId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const fetchProjectDetail = createAsyncThunk(
    'clientOrderAndPayment/fetchProjectDetailForDesign',
    async (projectId, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000));

            const response = await ClientPaymentAndOrderApi.fetchProjectDetail(projectId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const submitOrder = createAsyncThunk(
    'clientOrderAndPayment/submitOrder',
    async (formData, { rejectWithValue }) => {
        try {

            const response = await ClientPaymentAndOrderApi.submitOrder(formData);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);



export const addShippingAddress = createAsyncThunk(
    'clientOrderAndPayment/addShippingAddress',
    async (shippingAddressData, { rejectWithValue }) => {
        try {

            const response = await ClientPaymentAndOrderApi.addShippingAddress(shippingAddressData);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const toggleShippingAddressStatus = createAsyncThunk(
    'clientOrderAndPayment/toggleShippingAddressStatus',
    async (shippingAddressId, { rejectWithValue }) => {
        try {

            const response = await ClientPaymentAndOrderApi.toggleShippingAddressStatus(shippingAddressId.shippingAddressId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const fetchPaymentDetailAfterPayment = createAsyncThunk(
    'clientOrderAndPayment/fetchPaymentDetailAfterPayment',
    async (transactionId, { rejectWithValue }) => {
        try {
         
            const response = await ClientPaymentAndOrderApi.getPaymentDetailAfterPayment(transactionId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const clientOrderAndPaymentSlice = createSlice({
    name: 'clientOrderAndPayment',
    initialState: {
        productAvailableProperties: null,
        productAvailablePropertiesLoading: false,
        productAvailablePropertiesError: null,

        priceCalculator: null,
        priceCalculatorLoading: false,
        priceCalculatorError: null,

        projectOrProductDetailForDesign: null,
        projectOrProductDetailForDesignLoading: false,
        projectOrProductDetailForDesignError: null,



        orderSubmissionStatus: 'idle',
        orderSubmissionError: null,
        currentOrder: null,

        shippingAddress: null,
        shippingAddressLoading: false,
        shippingAddressError: null,

        toggleShippingAddressStatus: null,
        toggleShippingAddressStatusLoading: false,
        toggleShippingAddressStatusError: null,

        paymentDetailAfterPayment: null,
        paymentDetailAfterPaymentLoading: false,
        paymentDetailAfterPaymentError: null,


    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductAvailablePropertiesBeforeCheckout.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductAvailablePropertiesBeforeCheckout.fulfilled, (state, action) => {
                state.loading = false;
                state.productAvailableProperties = action.payload;
            })
            .addCase(fetchProductAvailablePropertiesBeforeCheckout.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // price calculator
            .addCase(priceCalculatorBeforeCheckout.pending, (state) => {
                state.priceCalculatorLoading = true;
                state.priceCalculatorError = null;
            })
            .addCase(priceCalculatorBeforeCheckout.fulfilled, (state, action) => {
                state.priceCalculatorLoading = false;
                state.priceCalculator = action.payload;
            })
            .addCase(priceCalculatorBeforeCheckout.rejected, (state, action) => {
                state.priceCalculatorLoading = false;
                state.priceCalculatorError = action.payload;
            })
            // fetch product detail or project detail for design
            .addCase(fetchProductDetail.pending, (state) => {
                state.projectOrProductDetailForDesignLoading = true;
                state.projectOrProductDetailForDesignError = null;
                state.projectOrProductDetailForDesign = null

            })
            .addCase(fetchProductDetail.fulfilled, (state, action) => {
                state.projectOrProductDetailForDesignLoading = false;
                state.projectOrProductDetailForDesign = action.payload;
            })
            .addCase(fetchProductDetail.rejected, (state, action) => {
                state.projectOrProductDetailForDesignLoading = false;
                state.projectOrProductDetailForDesignError = action.payload;
            })
            // fetch project detail for design
            .addCase(fetchProjectDetail.pending, (state) => {
                state.projectOrProductDetailForDesignLoading = true;
                state.projectOrProductDetailForDesignError = null;
                state.projectOrProductDetailForDesign = null
            })
            .addCase(fetchProjectDetail.fulfilled, (state, action) => {
                state.projectOrProductDetailForDesignLoading = false;
                state.projectOrProductDetailForDesign = action.payload;
            })
            .addCase(fetchProjectDetail.rejected, (state, action) => {
                state.projectOrProductDetailForDesignLoading = false;
                state.projectOrProductDetailForDesignError = action.payload;
            })
            // submit order
            .addCase(submitOrder.pending, (state) => {
                state.orderSubmissionStatus = 'loading';
                state.orderSubmissionError = null;
            })
            .addCase(submitOrder.fulfilled, (state, action) => {
                state.orderSubmissionStatus = 'succeeded';
                state.currentOrder = action.payload;
            })
            .addCase(submitOrder.rejected, (state, action) => {
                state.orderSubmissionStatus = 'failed';
                state.orderSubmissionError = action.payload;
            })
            // add shipping address
            .addCase(addShippingAddress.pending, (state) => {
                state.shippingAddressLoading = true;
                state.shippingAddressError = null;
            })
            .addCase(addShippingAddress.fulfilled, (state, action) => {
                state.shippingAddressLoading = false;
                state.shippingAddress = action.payload;
            })
            .addCase(addShippingAddress.rejected, (state, action) => {
                state.shippingAddressLoading = false;
                state.shippingAddressError = action.payload;
            })
            // toggle shipping address status
            .addCase(toggleShippingAddressStatus.pending, (state) => {
                state.toggleShippingAddressStatusLoading = true;
                state.toggleShippingAddressStatusError = null;
            })
            .addCase(toggleShippingAddressStatus.fulfilled, (state, action) => {
                state.toggleShippingAddressStatusLoading = false;
                state.toggleShippingAddressStatus = action.payload;
            })
            .addCase(toggleShippingAddressStatus.rejected, (state, action) => {
                state.toggleShippingAddressStatusLoading = false;
                state.toggleShippingAddressStatusError = action.payload;
            })
            // fetch payment detail after payment
            .addCase(fetchPaymentDetailAfterPayment.pending, (state) => {
                state.paymentDetailAfterPaymentLoading = true;
                state.paymentDetailAfterPaymentError = null;
            })
            .addCase(fetchPaymentDetailAfterPayment.fulfilled, (state, action) => {
                state.paymentDetailAfterPaymentLoading = false;
                state.paymentDetailAfterPayment = action.payload;
            })
            .addCase(fetchPaymentDetailAfterPayment.rejected, (state, action) => {
                state.paymentDetailAfterPaymentLoading = false;
                state.paymentDetailAfterPaymentError = action.payload;
            })


    },
});

export default clientOrderAndPaymentSlice.reducer;